export default "__VITE_ASSET__Ckr8bul2__"